module.exports = __webpack_public_path__ + "img/msoftstartups.9824d28b.jpg";